import { SelectorCardExpanderStates, SelectorCardExpanderStylesVariant, } from '../../../../../../components/selectorCardExpander/types/selectorCardExpanderTheme';
import { commonStyles } from '../commonStyles';
export const getDefaultStyles = (FOUNDATIONS, FONT) => ({
    [SelectorCardExpanderStylesVariant.DEFAULT]: {
        [SelectorCardExpanderStates.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, {
                text: {
                    color: FOUNDATIONS.color_neutral_font_50,
                },
            }),
        },
        [SelectorCardExpanderStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                text: {
                    color: FOUNDATIONS.color_neutral_font_50,
                },
            }),
        },
        [SelectorCardExpanderStates.DISABLED]: {
            ...commonStyles(FOUNDATIONS, {
                text: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
            }),
        },
        [SelectorCardExpanderStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                text: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
            }),
        },
    },
});
//# sourceMappingURL=default.js.map